"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRequestSchema = void 0;
const zod_1 = require("zod");
const subjectField_schema_1 = require("../../../common/schemas/subjectField.schema");
const userWithUserId_schema_1 = require("../../../common/schemas/userWithUserId.schema");
const selectedItem_schema_1 = require("../../../common/schemas/selectedItem.schema");
const longField_schema_1 = require("../../../common/schemas/longField.schema");
const attachments_schema_1 = require("../../../common/schemas/attachments.schema");
const uniqueForIdValue_1 = require("../../../common/schemas/helpers/uniqueForIdValue");
const uniqueForCustomizableValue_1 = require("../../../common/schemas/helpers/uniqueForCustomizableValue");
const datetime_schema_1 = require("../../../common/schemas/datetime.schema");
const shortField_schema_1 = require("../../../common/schemas/shortField.schema");
const selectedItemWithCustomNameSchema_schema_1 = require("../../../common/schemas/selectedItemWithCustomNameSchema.schema");
exports.createRequestSchema = zod_1.z
    .object({
    subject: subjectField_schema_1.subjectFieldSchema,
    to: userWithUserId_schema_1.userWithUserIdSchema.array().nonempty(),
    dueDate: datetime_schema_1.datetimeSchema,
    number: shortField_schema_1.shortFieldSchema.optional(),
    senderNumber: shortField_schema_1.shortFieldSchema.optional(),
    revisionNumber: zod_1.z.string().optional(),
    autoRevisionNumber: zod_1.z.boolean().optional(),
    specSection: selectedItemWithCustomNameSchema_schema_1.selectedItemWithCustomNameSchema,
    disciplines: selectedItem_schema_1.selectedItemSchema
        .array()
        .optional()
        .refine(...(0, uniqueForIdValue_1.uniqueForIdValue)(uniqueForCustomizableValue_1.uniqueDisciplinesMessage)),
    keywords: selectedItemWithCustomNameSchema_schema_1.selectedItemWithCustomNameSchema
        .array()
        .optional()
        .refine(...(0, uniqueForCustomizableValue_1.uniqueForCustomizableValue)(uniqueForCustomizableValue_1.uniqueKeywordsMessage)),
    purpose: selectedItem_schema_1.selectedItemSchema,
    description: longField_schema_1.longFieldSchema.optional(),
    attachments: attachments_schema_1.optionalAttachmentsSchema,
})
    .strict();
//# sourceMappingURL=createRequest.schema.js.map